module.exports = __webpack_public_path__ + "static/media/brl.9eb59cc4.png";